import { render, staticRenderFns } from "./TicketDescriptionForm.vue?vue&type=template&id=81d48030&"
import script from "./TicketDescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./TicketDescriptionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports